import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import MenuItemCard from './components/MenuItemCard';
import OrderSummaryCard from './components/OrderSummaryCard';
import DeliveryInfoCard from './components/DeliveryInfoCard';
import CategoryFilter from './components/CategoryFilter';
import OrderHistoryModal from './components/OrderHistoryModal';

const OrderNow = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [selectedZone, setSelectedZone] = useState(1);
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showOrderHistory, setShowOrderHistory] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const menuItems = [
  {
    id: 1,
    name: "Beef Rolex",
    description: "Delicious chapati rolled with seasoned beef, eggs, and fresh vegetables. A hearty and satisfying meal.",
    price: 30000,
    image: "https://images.unsplash.com/photo-1681072530653-db8fe2538631",
    imageAlt: "Beef rolex wrap with golden chapati filled with seasoned beef and vegetables on white plate",
    category: "rolex",
    tags: ["Popular", "High Protein"],
    isPopular: true,
    isNew: false
  },
  {
    id: 2,
    name: "Chicken Rolex",
    description: "Soft chapati wrapped with tender chicken, eggs, and crisp vegetables. A popular street food favorite.",
    price: 20000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c6e3273b-1772057295634.png",
    imageAlt: "Chicken rolex with grilled chicken and fresh vegetables wrapped in warm chapati",
    category: "rolex",
    tags: ["Popular", "Quick"],
    isPopular: true,
    isNew: false
  },
  {
    id: 3,
    name: "Vegetable Rolex",
    description: "Fresh chapati filled with eggs and a colorful mix of vegetables. Perfect for vegetarians.",
    price: 20000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c6e3273b-1772057295634.png",
    imageAlt: "Vegetable rolex with fresh vegetables and eggs wrapped in soft chapati",
    category: "rolex",
    tags: ["Vegetarian", "Healthy"],
    isPopular: true,
    isNew: false
  },
  {
    id: 4,
    name: "Egg Rolex",
    description: "Simple yet delicious chapati rolled with scrambled eggs and vegetables. A quick and tasty option.",
    price: 10000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cb342d88-1766170472463.png",
    imageAlt: "Egg rolex with fluffy scrambled eggs wrapped in golden chapati",
    category: "rolex",
    tags: ["Quick", "Vegetarian"],
    isPopular: false,
    isNew: false
  },
  {
    id: 5,
    name: "Fruit Salad Combo",
    description: "Fresh seasonal fruits mixed together. A healthy and refreshing choice.",
    price: 20000,
    image: "https://images.unsplash.com/photo-1615221192568-79778ddbc2cb",
    imageAlt: "Colorful fresh fruit salad with mixed tropical fruits in bowl",
    category: "snacks",
    tags: ["Healthy", "Fresh"],
    isPopular: true,
    isNew: false
  },
  {
    id: 6,
    name: "Chichiko Mando",
    description: "Traditional South Sudanese snack. Crispy and flavorful.",
    price: 14000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1afe02339-1774200738930.png",
    imageAlt: "Traditional South Sudanese snack on plate",
    category: "snacks",
    tags: ["Traditional", "Snack"],
    isPopular: false,
    isNew: false
  },
  {
    id: 7,
    name: "Water",
    description: "Refreshing bottled water to quench your thirst.",
    price: 2000,
    image: "https://images.unsplash.com/photo-1655079343782-f0fc4704753e",
    imageAlt: "Clear bottled water on white background",
    category: "beverages",
    tags: ["Essential"],
    isPopular: false,
    isNew: false
  },
  {
    id: 8,
    name: "Soda",
    description: "Chilled carbonated soft drink. Various flavors available.",
    price: 5000,
    image: "https://images.unsplash.com/photo-1698858008474-d182aaec70aa",
    imageAlt: "Cold soda bottle with condensation on glass",
    category: "beverages",
    tags: ["Cold", "Refreshing"],
    isPopular: true,
    isNew: false
  },
  {
    id: 9,
    name: "Fresh Juice",
    description: "Freshly squeezed fruit juice. Made to order with natural ingredients.",
    price: 15000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dbee6a56-1772577947194.png",
    imageAlt: "Fresh fruit juice in glass with colorful fruits",
    category: "beverages",
    tags: ["Fresh", "Healthy"],
    isPopular: true,
    isNew: false
  },
  {
    id: 10,
    name: "Fresh Voja",
    description: "Traditional fresh beverage. Locally sourced and naturally refreshing.",
    price: 15000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_159833053-1773102260550.png",
    imageAlt: "Traditional fresh beverage in glass with natural ingredients",
    category: "beverages",
    tags: ["Traditional", "Fresh"],
    isPopular: false,
    isNew: false
  },
  {
    id: 11,
    name: "Pepsi Can",
    description: "Classic Pepsi cola in a convenient can. Ice cold and refreshing.",
    price: 7000,
    image: "https://images.unsplash.com/photo-1554283180-2eb141938ee9",
    imageAlt: "Pepsi can with condensation droplets on blue background",
    category: "beverages",
    tags: ["Cold", "Popular"],
    isPopular: true,
    isNew: false
  },
  {
    id: 12,
    name: "Black Tea",
    description: "Hot black tea brewed to perfection. Simple and comforting.",
    price: 5000,
    image: "https://images.unsplash.com/photo-1632777012009-0ca895926882",
    imageAlt: "Cup of hot black tea with steam rising on saucer",
    category: "beverages",
    tags: ["Hot", "Classic"],
    isPopular: true,
    isNew: false
  },
  {
    id: 13,
    name: "Africa Tea",
    description: "Traditional African tea blend with aromatic spices. Rich and flavorful.",
    price: 10000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16d8340a4-1772253720983.png",
    imageAlt: "Traditional African spiced tea in decorative cup with spices",
    category: "beverages",
    tags: ["Traditional", "Spiced"],
    isPopular: true,
    isNew: false
  },
  {
    id: 14,
    name: "Milk Tea",
    description: "Creamy tea with milk. Smooth and satisfying.",
    price: 10000,
    image: "https://images.unsplash.com/photo-1647759887093-bc5023ed586d",
    imageAlt: "Creamy milk tea in glass cup with milk swirl",
    category: "beverages",
    tags: ["Creamy", "Popular"],
    isPopular: true,
    isNew: false
  },
  {
    id: 15,
    name: "Black Coffee",
    description: "Strong black coffee. Perfect for coffee lovers who enjoy it pure.",
    price: 7000,
    image: "https://images.unsplash.com/photo-1691775755067-a9807ac8939c",
    imageAlt: "Cup of black coffee with steam on dark background",
    category: "beverages",
    tags: ["Hot", "Strong"],
    isPopular: true,
    isNew: false
  },
  {
    id: 16,
    name: "Cappuccino",
    description: "Classic cappuccino with rich espresso and creamy milk foam.",
    price: 10000,
    image: "https://images.unsplash.com/photo-1601819713498-eb04a642dee9",
    imageAlt: "Cappuccino with milk foam art in white cup on saucer",
    category: "beverages",
    tags: ["Coffee", "Creamy"],
    isPopular: true,
    isNew: false
  }];


  const categories = [
  { id: 'all', name: 'All Items', icon: 'Grid3x3', count: menuItems?.length },
  { id: 'rolex', name: 'Rolex', icon: 'Package', count: menuItems?.filter((i) => i?.category === 'rolex')?.length },
  { id: 'snacks', name: 'Snacks', icon: 'Cookie', count: menuItems?.filter((i) => i?.category === 'snacks')?.length },
  { id: 'beverages', name: 'Beverages', icon: 'Coffee', count: menuItems?.filter((i) => i?.category === 'beverages')?.length }];


  const orderHistory = [
  {
    id: "ORD-2026-001",
    date: "January 2, 2026",
    status: "Delivered",
    total: 3000,
    items: [
    { name: "Classic Chapati Combo", quantity: 2, price: 1500 }]

  },
  {
    id: "ORD-2025-128",
    date: "December 28, 2025",
    status: "Delivered",
    total: 2600,
    items: [
    { name: "Spicy Beef Chapati Wrap", quantity: 1, price: 1200 },
    { name: "Chicken Tikka Chapati", quantity: 1, price: 1400 }]

  }];


  const deliveryZones = [
  { id: 1, name: "Juba City Center", fee: 500, time: "20-30 min" },
  { id: 2, name: "Gudele", fee: 800, time: "30-40 min" },
  { id: 3, name: "Konyokonyo", fee: 700, time: "25-35 min" },
  { id: 4, name: "Munuki", fee: 900, time: "35-45 min" },
  { id: 5, name: "Jebel", fee: 1000, time: "40-50 min" }];


  const currentZone = deliveryZones?.find((z) => z?.id === selectedZone);
  const deliveryFee = cartItems?.reduce((sum, item) => sum + item?.price * item?.quantity, 0) >= 5000 ? 0 : currentZone?.fee || 0;

  const filteredItems = menuItems?.filter((item) => {
    const matchesCategory = activeCategory === 'all' || item?.category === activeCategory;
    const matchesSearch = item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    item?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleAddToCart = (item) => {
    const existingItem = cartItems?.find((i) => i?.id === item?.id && i?.customization === item?.customization);
    if (existingItem) {
      setCartItems(cartItems?.map((i) =>
      i?.id === item?.id && i?.customization === item?.customization ?
      { ...i, quantity: i?.quantity + item?.quantity } :
      i
      ));
    } else {
      setCartItems([...cartItems, item]);
    }
  };

  const handleRemoveItem = (itemId) => {
    setCartItems(cartItems?.filter((item) => item?.id !== itemId));
  };

  const handleUpdateQuantity = (itemId, newQuantity) => {
    if (newQuantity === 0) {
      handleRemoveItem(itemId);
    } else {
      setCartItems(cartItems?.map((item) =>
      item?.id === itemId ? { ...item, quantity: newQuantity } : item
      ));
    }
  };

  const handleCheckout = () => {
    if (cartItems?.length === 0) return;

    const orderDetails = cartItems?.map((item) =>
    `${item?.quantity}x ${item?.name}${item?.customization ? ` (${item?.customization})` : ''} - SSP ${(item?.price * item?.quantity)?.toLocaleString()}`
    )?.join('\n');

    const subtotal = cartItems?.reduce((sum, item) => sum + item?.price * item?.quantity, 0);
    const total = subtotal + deliveryFee;

    const message = `Hello Chapati Plus! I would like to place an order:\n\n${orderDetails}\n\nDelivery Zone: ${currentZone?.name}\nSubtotal: SSP ${subtotal?.toLocaleString()}\nDelivery Fee: SSP ${deliveryFee?.toLocaleString()}\nTotal: SSP ${total?.toLocaleString()}\n\nPlease confirm my order. Thank you!`;

    window.open(`https://wa.me/211915497014?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleReorder = (order) => {
    const reorderedItems = order?.items?.map((item) => {
      const menuItem = menuItems?.find((m) => m?.name === item?.name);
      return menuItem ? { ...menuItem, quantity: item?.quantity, customization: null } : null;
    })?.filter(Boolean);

    setCartItems([...cartItems, ...reorderedItems]);
    setShowOrderHistory(false);
  };

  return (
    <>
      <Helmet>
        <title>Order Now - Chapati Plus | Fresh South Sudanese Food Delivery</title>
        <meta name="description" content="Order authentic South Sudanese chapatis and meals online. Fast delivery across Juba with WhatsApp ordering. Fresh ingredients, traditional flavors." />
      </Helmet>
      <div className="min-h-screen bg-background flex flex-col">
        <Header />

        <main className="flex-1 pt-20 pb-8 md:pb-12 lg:pb-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-6 md:mb-8 lg:mb-12">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-3 md:mb-4">
                Order Your Favorite Meals
              </h1>
              <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
                Fresh chapatis and authentic South Sudanese flavors delivered to your door. Customize your order and enjoy!
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-4 md:gap-6 lg:gap-8 mb-6 md:mb-8">
              <div className="flex-1">
                <Input
                  type="search"
                  placeholder="Search menu items..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e?.target?.value)}
                  className="w-full" />

              </div>
              <Button
                variant="outline"
                size="default"
                iconName="History"
                iconPosition="left"
                onClick={() => setShowOrderHistory(true)}>

                Order History
              </Button>
            </div>

            <CategoryFilter
              categories={categories}
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory} />


            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
              <div className="lg:col-span-2 space-y-6 md:space-y-8">
                <DeliveryInfoCard
                  selectedZone={selectedZone}
                  deliveryFee={deliveryFee}
                  estimatedTime={currentZone?.time || 'N/A'} />


                {filteredItems?.length === 0 ?
                <div className="text-center py-12 md:py-16 bg-card rounded-xl">
                    <Icon name="Search" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
                    <p className="text-muted-foreground text-base md:text-lg">No items found matching your search</p>
                  </div> :

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                    {filteredItems?.map((item) =>
                  <MenuItemCard
                    key={item?.id}
                    item={item}
                    onAddToCart={handleAddToCart} />

                  )}
                  </div>
                }
              </div>

              <div className="lg:col-span-1">
                <OrderSummaryCard
                  items={cartItems}
                  deliveryFee={deliveryFee}
                  onRemoveItem={handleRemoveItem}
                  onUpdateQuantity={handleUpdateQuantity}
                  onCheckout={handleCheckout} />

              </div>
            </div>

            <div className="mt-8 md:mt-12 bg-primary/10 rounded-xl p-4 md:p-6 lg:p-8 border border-primary/30">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="MessageCircle" size={24} color="var(--color-primary)" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg md:text-xl font-bold text-foreground mb-2">Need Help with Your Order?</h3>
                  <p className="text-sm md:text-base text-muted-foreground mb-3 md:mb-4">
                    Our team is ready to assist you via WhatsApp or phone. We're here to make your ordering experience smooth and enjoyable.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <Button
                      variant="default"
                      size="default"
                      iconName="MessageCircle"
                      iconPosition="left"
                      onClick={() => window.open('https://wa.me/211915497014', '_blank')}
                      className="bg-accent hover:bg-accent/90">

                      Chat on WhatsApp
                    </Button>
                    <Button
                      variant="outline"
                      size="default"
                      iconName="Phone"
                      iconPosition="left"
                      onClick={() => window.open('tel:+211915497014', '_self')}>

                      Call Us Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />

        <OrderHistoryModal
          isOpen={showOrderHistory}
          onClose={() => setShowOrderHistory(false)}
          orderHistory={orderHistory}
          onReorder={handleReorder} />

      </div>
    </>);

};

export default OrderNow;